// @flow
import { QuestionSurveysActionTypes } from './constants';

type QuestionSurveysAction = { type: string, payload: {} | string };

// common success
export const questionSurveysApiResponseSuccess = (actionType: string, data: any): QuestionSurveysAction => ({
    type: QuestionSurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const questionSurveysApiResponseError = (actionType: string, error: string): QuestionSurveysAction => ({
    type: QuestionSurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getQuestionSurvey = (id: string): QuestionSurveysAction => ({
    type: QuestionSurveysActionTypes.GET_QUESTION_SURVEY,
    payload: { id },
});

export const addQuestionSurvey = (questionSurvey:any):QuestionSurveysAction=>({
    type:QuestionSurveysActionTypes.ADD_QUESTION_SURVEY,
    payload:questionSurvey
})
export const updateQuestionSurvey = (questionSurvey:any):QuestionSurveysAction=>({
    type:QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY,
    payload:questionSurvey
})
export const deleteQuestionSurvey = (id:string):QuestionSurveysAction=>({
    type:QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY,
    payload:{id}
})

export const listQuestionSurveys = (params:any): QuestionSurveysAction => ({
    type: QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS,
    payload: params,
});


export const resetQuestionSurveys = (): QuestionSurveysAction => ({
    type: QuestionSurveysActionTypes.RESET,
    payload: {},
});

